import { axios, Response } from '../index'

export const removeInviteTherapists = (personaId: string): Response<null> => {
  return axios.delete(`/v1/personas/${personaId}/remove-invite`)
}

export default removeInviteTherapists
